var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "payment-wrap" }, [
    _c(
      "div",
      { staticClass: "c-page-pay" },
      [
        _vm.familyModal
          ? _c(
              "Dialog",
              {
                attrs: { title: "家长代付" },
                on: {
                  close: function($event) {
                    _vm.familyModal = false
                  }
                }
              },
              [
                _c("div", { staticClass: "modal-wechat" }, [
                  _c("p", { staticClass: "color-17181A fs-16 lh-24 sybold" }, [
                    _vm._v(" 复制并通过微信分享给你的父母"),
                    _c("br"),
                    _c(
                      "span",
                      { staticClass: "color-377ECF fs-16 lh-24 sybold" },
                      [_vm._v(_vm._s(_vm.guestPayLink))]
                    )
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass: "copy-wrap mt-40 J-click-copy",
                    attrs: { "data-clipboard-text": _vm.guestPayLink },
                    on: { click: _vm.handleClickCopy }
                  },
                  [_c("Button", { attrs: { skin: "red" } }, [_vm._v("复制")])],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm.weChatModal
          ? _c(
              "Dialog",
              {
                attrs: { title: "微信支付" },
                on: { close: _vm.closeWeChatModal }
              },
              [
                _c(
                  "div",
                  { staticClass: "modal-wechat" },
                  [
                    _c("Qr", {
                      attrs: { className: "img-qr", text: _vm.qr, size: 130 }
                    }),
                    _c("div", { staticClass: "pay-message" }, [
                      _c(
                        "p",
                        { staticClass: "color-17181A fs-16 lh-24 sybold" },
                        [_vm._v("如何支付")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "pt-10 color-494A4D fs-14 lh-21 synormal pc-only"
                        },
                        [_vm._v("进入微信“扫一扫”扫描二维码后支付")]
                      ),
                      _c(
                        "p",
                        {
                          staticClass:
                            "pt-10 color-494A4D fs-14 lh-21 synormal m-only"
                        },
                        [
                          _vm._v(
                            "请长按保存左侧二维码后，进入微信“扫一扫”，并从相册选取次二维码图片后支付。"
                          )
                        ]
                      )
                    ])
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _vm.aliModal
          ? _c(
              "Dialog",
              { attrs: { title: "支付" }, on: { close: _vm.closeAliModal } },
              [
                _c(
                  "div",
                  { staticClass: "modal-ali" },
                  [
                    _c(
                      "Button",
                      {
                        attrs: { className: "item", skin: "black" },
                        on: { click: _vm.closeAliModal }
                      },
                      [_vm._v("遇到问题 重新付款")]
                    ),
                    _c(
                      "Button",
                      {
                        attrs: { className: "item", skin: "red" },
                        on: { click: _vm.handleClickSuccess }
                      },
                      [_vm._v("已完成支付")]
                    )
                  ],
                  1
                )
              ]
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "page-content" },
          [
            _c("h1", { staticClass: "h1 color-black" }, [_vm._v("支付费用")]),
            _vm._m(0),
            _c("p", { staticClass: "text1 color-gray-1 mt-30" }, [
              _vm._v(
                " 祝贺你，通过个人努力和严格筛选，被录取成为2022哈佛商学院案例青年财经分析师科研计划（Student Business Pioneer powered by Harvard Business Publishing）的正式学员！ "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 哈佛商学院案例青年财经分析师科研计划（SBP）收到了几百份优秀学生的申请材料，并采取了哈佛校园有选拔性的学术和实习机会通用的comping挑战流程，不仅用一次面试选拔，而是在整个峰会活动的各个板块中综合考量你的学术成绩、案例群面表现和授课人推荐，选拔出了一小群综合竞争力突出的同学入选。你在Comping流程中所展现出的沟通能力、结构化思维、中英文表达能力、协作能力、和商业敏感度，令案例面试官印象深刻，使你从上千名峰会参与者中脱颖而出。我们很高兴能够通过申请过程认识这样一个你，并且非常期待在这个金秋在线下的商学院课堂见到你。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 bold mt-20" }, [
              _vm._v("接下来将发生什么？")
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 2022年秋季的SBP项目和疫情以来的过去两年一样，将采用Hybrid形式开展，即三周线上学术课程和研究+4天线下高强度学术课程和挑战。整体项目跨度为9月17日-10月16日。线上三周期间，将集中在周末时间、周中晚上时间进行线上案例研讨（中文、英文皆有）；线下活动部分将在哈佛在中国的官方代表中心——哈佛中心（上海）举行。线下日期（暂定）：10月2、3、4、5日。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
              _vm._v(
                " 被SBP录取的同学将成为在哈佛中心（上海）正式完成哈佛商学院案例研究学术项目年龄最小的学生，在九月下旬在这里连续几天与大洋彼岸哈佛学者video conference、与现场一系列国内外名校学者面对面高强度学术交流，深入了解商学院的全真课程，并深入案例相关行业龙头企业中实地参访（根据当地疫情情况），和企业话事人近距离交流、和商业领域教授专家平等探讨，并将商学院教学方法带回学校，成为同学中的引领者。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
              _vm._v(
                " 由于疫情相关要求，多地学校开学后对出省市返回有不同的政策，SBP项目组届时将会针对不能出省市的同学，探索不同形式的参与方式，包括线上线下的hybrid融合模式等，组委会将与确认出席的同学及所在学校保持密切沟通，关注疫情政策更新并提供帮助你顺利参与的方式。 "
              )
            ]),
            _vm._m(1),
            _c("p", { staticClass: "text1 color-gray-1 bold mt-20" }, [
              _vm._v("成为Student Business Pioneer，你将获得：")
            ]),
            _vm._m(2),
            _c("p", { staticClass: "text1 color-gray-1 bold mt-20" }, [
              _vm._v("下一步需要做什么？")
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 有任何关于SBP和你的席位的问题，欢迎致电400-180-5580转2，也可以写邮件至sbp@hsylc.cn，由组委会老师解答。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                "请支付项目费用，在此之后，你的SBP席位将正式确认，开始课程前阅读材料准备等工作。"
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 说明：SBP参照哈佛商学院案例研讨课堂配置仅有90个学生席位，还有许多的同学在等候名单上。如果过了截止日期还未确认或支付，经沟通提醒后将视作放弃席位，席位将顺延给等候名单上下一位同学。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 bold mt-20" }, [
              _vm._v("支付项目费用")
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 祝贺你已经获得哈佛商学院案例青年财经分析师科研计划（Student Business Pioneer powered by Harvard Business Publishing）学生资格，请缴纳SBP项目费用，以正式锁定SBP的学生席位。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 2022年SBP费用与疫情以来两年SBP及疫情前历年哈佛实地交换生HWeek的项目部分费用保持一致，全部项目费用为3,500美元（23,730 元人民币），汇率=6.7813（中国银行2022年8月3日美元兑人民币汇率中间价）。像哈佛商学院一样，SBP项目提供部分助学金，用于资助经济有较大困难的同学，具体申请方法请见下方。 "
              )
            ]),
            _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
              _vm._v(
                " 项目费用包含哈佛商学院全部原版学术资料独家版权支付、独家授权项目注册、跨三周全程与哈佛商学院、哈佛各其他学院等名校学者的高强度学术研讨和交流、哈佛原版学术阅读材料、论文文献、哈佛商学院商业模拟（Simulation）技术系统、独家授权技术平台和账号、国内外知名大学师资和独家活动、哈佛商学院出版官方授权项目证书、哈佛中心线下活动期间一日三餐和活动材料等。项目费用不包含：上海住宿费用、往返会场和外地往返上海的交通费。以上安排与往年活动保持不变。 "
              )
            ]),
            _vm._m(3),
            _c(
              "div",
              {
                staticClass: "checkBox-line font16 syNormal marginTop30",
                on: { click: _vm.handleConfirm }
              },
              [
                _c(
                  "div",
                  {
                    staticClass: "tick-wrap",
                    class: _vm.isConfirm ? "active" : ""
                  },
                  [
                    _c("Tick", {
                      staticClass: "icon",
                      attrs: { color: _vm.tickColor }
                    })
                  ],
                  1
                ),
                _c("div", { staticClass: "text" }, [
                  _vm._v(" 我已阅读 "),
                  _c(
                    "span",
                    {
                      staticClass: "color-A11A22 sybold",
                      attrs: { "data-pageName": "pay-admission-notices" },
                      on: {
                        click: function($event) {
                          return _vm.windowOpen("/sbp/announcement")
                        }
                      }
                    },
                    [
                      _vm._v(
                        " 哈佛商学院案例研究青年财经分析师科研计划（SBP）项目付款及取消须知 "
                      )
                    ]
                  ),
                  _vm._v(" 的全文并完全同意。 ")
                ])
              ]
            ),
            _c("p", { staticClass: "sybold mt-30 color-17181A fs-16 lh-24" }, [
              _vm._v("选择支付方式")
            ]),
            _c("PayChannel", {
              staticClass: "mt-10",
              attrs: {
                value: _vm.channel,
                family: true,
                channels: _vm.channels
              },
              on: { input: _vm.handleChannelInput }
            }),
            _vm.isOver
              ? _c(
                  "div",
                  { staticClass: "color-E61717 font16 syNormal marginTop10" },
                  [
                    _c("strong", [
                      _vm._v(
                        "你未在组委会指定日期内完成费用支付，默认为放弃峰会学生资格。如有问题请联系组委会。"
                      )
                    ])
                  ]
                )
              : _vm._e(),
            _c("div", { staticClass: "marginBottom100" })
          ],
          1
        ),
        _c("div", { staticClass: "pay-footer" }, [
          _c(
            "div",
            { staticClass: "footer-content" },
            [
              _c("p", { staticClass: "pay-info color-7C7D80" }, [
                _vm._v(" 项目费用："),
                _c("span", { staticClass: "sybold color-A11A22 bold" }, [
                  _vm._v("¥")
                ]),
                _c("span", { staticClass: "sybold price color-A11A22" }, [
                  _vm._v(_vm._s(_vm.payPrice))
                ])
              ]),
              _vm.status === _vm.STATUS.PAY && !_vm.isOver && _vm.feeData
                ? _c(
                    "Button",
                    {
                      attrs: {
                        className: "btn-pay",
                        skin: "red",
                        customStyle: { height: "100%" }
                      },
                      on: { click: _vm.handleClickPay }
                    },
                    [_vm._v(" 付款 ")]
                  )
                : _vm.isOver || !_vm.feeData
                ? _c(
                    "Button",
                    {
                      attrs: {
                        className: "btn-pay",
                        disabled: "",
                        customStyle: { height: "100%" }
                      }
                    },
                    [_vm._v("付款")]
                  )
                : _vm.status === _vm.STATUS.PAID
                ? _c(
                    "Button",
                    {
                      attrs: {
                        className: "btn-pay",
                        disabled: "",
                        customStyle: { height: "100%" }
                      }
                    },
                    [_vm._v("已付款")]
                  )
                : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: {
          src: "//hsylc.oss-cn-hangzhou.aliyuncs.com/2021/sbp/image3.jpg",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "img-wrap" }, [
      _c("img", {
        attrs: {
          src: "//hsylc.oss-cn-hangzhou.aliyuncs.com/2021/sbp/image6.png",
          alt: ""
        }
      })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("ul", { staticClass: "ul text1 color-gray-1 mt-10" }, [
      _c("li", [
        _vm._v("基于哈佛商学院案例的全英文财经商业分析科研成果和论文")
      ]),
      _c("li", [_vm._v("哈佛商学院案例分析SBP项目青年财经分析师证书")]),
      _c("li", [
        _vm._v("成果最杰出课题组成员获得组委会联合行业导师出具的推荐信（5-8%）")
      ]),
      _c("li", [
        _vm._v("突出课题在哈佛商学院出版中国K12领域官方授权平台刊登发表")
      ]),
      _c("li", [_vm._v("跨科技、消费、文化、艺术多领域的真实行业案例涉猎")]),
      _c("li", [_vm._v("与海内外知名企业一线决策者直接对话机会")])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text1 color-gray-1 mt-10" }, [
      _vm._v(
        " SBP项目和哈佛商学院一样提供部分助学金支持，用于支持经济有较大困难的学生可以顺利出席活动。如果你在峰会里已经是助学金获得者，请直接回复你的录取信邮件，或发送邮件至sbp@hsylc.cn表达你希望获得资助的具体情况，不需要重新提交一次证明文件。如果你不是峰会的助学金获得者，但是有经济困难需要申请SBP项目的助学金，现在则需要重新提交一次全套的经济证明材料。请在项目费用截止日期前完成助学金完整申请表的填写， "
      ),
      _c(
        "a",
        {
          staticClass: "link color-red-default bold",
          attrs: { href: "https://jinshuju.net/f/lXKXj2", target: "_blank" }
        },
        [_vm._v(" 表格点击这里打开 ")]
      ),
      _vm._v(
        " 。其中需要你上传家庭经济证明（例如工资证明等），以及学校盖章证明，需要学校盖章的文件 "
      ),
      _c(
        "a",
        {
          staticClass: "color-red-default bold link",
          attrs: {
            href:
              "https://files.hsylc.cn/cloud-uploads/user-2/SBP_2022/2022_sbp_application.pdf",
            target: "_blank"
          }
        },
        [_vm._v(" 点击这里下载 ")]
      ),
      _vm._v(
        " 。在收到你的完整助学金申请后，我们会在1-2天内完成助学金审核，发给你审核结果，然后你可以进行下一步的流程。 "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }